<template>
  <div>
    <div class="d-flex">
      <div :class="`wd-${disableAdd ? '100p' : '80p'}`">
        <Cascader
          :placeholder="placeholder"
          filterable
          :options="list"
          :props="{ checkStrictly: checkStrictly }"
          v-model="cascaderSelected"
          @change="cascaderOnChange"
          :disabled="disabled"
          clearable
          style="width:100%"
          :size="size"
        ></Cascader>

        <!-- <template slot-scope="{ node, data }">
        <span>{{ data.label }} </span>
        <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
        
        </template>-->
      </div>

      <div
        v-if="
          hasPermission([
            'admin',
            'planadmin',
            'hradmin',
            'archiveadmin',
            'tushaaladmin',
            'crmadmin',
            'contentadmin',
            'webadmin',
            'learningadmin'
          ]) &&
            !disabled &&
            !disableAdd
        "
        class="wd-10p mg-l-5"
      >
        <!-- <Button class="ivu-btn ivu-btn-default" :size="size" @click="showModal()">
          <b-icon icon="plus"></b-icon>
        </Button>-->
        <button
          class="btn btn-outline-light"
          @click.stop="showModal()"
          type="button"
        >
          <b-icon icon="plus"></b-icon>
        </button>
      </div>
    </div>
    <b-modal
      v-model="modalShow"
      @hide="modalClose()"
      scrollable
      
      centered
      body-class="pd-0"
      size="lg"
    >
    <template #modal-header>
      <!-- <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30"> -->
        <a
          role="button"
          aria-label="Close"
          class="close pos-absolute t-15 r-15"
          @click="modalClose()"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <feather type="folder"></feather>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">
              Төрөл {{ selectedTypeId == 0 ? "үүсгэх" : "засах" }}
            </h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              Тохирох утгуудыг бөглөөд хадгалах дарна уу
            </p>
          </div>
        </div>
      <!-- </div> -->
    </template>
      <div class="d-flex">
        <div class="wd-40p">
          <div class="pd-10 bg-white bd-b">
            <button
              class="btn btn-outline-light btn-xs btn-block"
              @click="addSub(0)"
            >
              <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i> Шинэ төрөл
              үүсгэх 
            </button>
          </div>
          <Tree
            class="tree-sel-filemenu manual-tree"
            :data="list"
            @node-click="handleTreeSelect"
          ></Tree>
        </div>
        <div class="wd-60p bd-l">
          <div class="pd-10 bg-white bd-b" v-if="selectedTypeId != 0">
            <!-- <Button @click="addSub(0)" type="success">
                <i class="ivu-icon ivu-icon-md-add"></i> Шинэ
            </Button>-->
            <!-- <span>{{selectedLabel}}</span> -->
            <!-- <button
              type="warning"
              class="btn btn-outline-warning btn-xs mg-r-5"
              @click="editSub(selectedTypeId)"
            >+
              <i class="icon ion-md-settings tx-14 mg-r-5 pd-t-5"></i> Засах
            </button>-->
            <button
              class="btn btn-outline-primary btn-xs"
              @click="addSub(selectedTypeId)"
            >
              <i class="icon ion-md-add tx-14 mg-r-5 pd-t-5"></i> Дэд төрөл
              нэмэх
            </button>
            <button
              class="btn btn-outline-danger btn-xs"
              @click="deleteType(selectedTypeId)"
              v-if="
                hasPermission([
                  'admin',
                  'hradmin',
                  'archiveadmin',
                  'tushaaladmin',
                  'crmadmin',
                  'contentadmin',
                  'webadmin',
                  'learningadmin'
                ])
              "
            >
              <i class="icon ion-md-trash tx-14 mg-r-5 pd-t-5 mg-l-5"></i>
              Устгах
            </button>
            <!-- <ButtonGroup>
              <Button v-if="selectedTypeId != 0" type="warning" @click="editSub(selectedTypeId)">
                <i class="ivu-icon ivu-icon-md-settings"></i> Засах
              </Button>
              <Button v-if="selectedTypeId != 0" type="primary" @click="addSub(selectedTypeId)">
                <i class="ivu-icon ivu-icon-md-share"></i> Дэд төрөл нэмэх
              </Button>
            </ButtonGroup>-->
          </div>
          <Form v-show="editMode" v-model="locTypeModel" class="pd-10">
            <FormItem label="Парент" class="m-b-sm">
              <span
                v-if="
                  listFlat.filter(x => x.id == locTypeModel.parentId).length > 0
                "
                >{{
                  listFlat.filter(x => x.id == locTypeModel.parentId)[0].title
                }}</span
              >
              <span v-else>~</span>
            </FormItem>
            <FormItem label="Нэр" class="m-b-sm">
              <!-- <Input v-model="locTypeModel.name" placeholder="___" /> -->
              <input v-model="locTypeModel.name" placeholder="___" type="text" class="el-input__inner" />
            </FormItem>
            <FormItem label="Утга" class="m-b-sm">
              <Input v-model="locTypeModel.value" placeholder="___" />
            </FormItem>
            <FormItem
              :label="getLbl()"
              class="m-b-sm"
            >
              <Input v-model="locTypeModel.code" placeholder="___" />
            </FormItem>
            <FormItem label="Дараалал" class="m-b-sm">
              <InputNumber
                v-model="locTypeModel.ord"
                placeholder="___"
              ></InputNumber>
            </FormItem>
            <FormItem
              :label="
                `${
                  locTypeModel.key == 'courseType'
                    ? 'Сертификат загвар'
                    : 'Хавсралт'
                }`
              "
              class="m-b-sm"
            >
              <simple-uploader
                v-model="locTypeModel.attachId"
                :propObjectTypeId="6"
                @on-success="fileUploaded"
              >
                <div slot="trigger">
                  <div
                    v-if="locTypeModel.attachId == null"
                    class="btn btn-primary"
                  >
                    <label style="margin-btoom: 0" class="custom-file-label"
                      >Файл сонгоогүй байна</label
                    >
                  </div>
                  <div v-else class="btn-group wd-100p ht-40-f">
                    <div
                      class="btn btn-outline-primary wd-50p"
                      @click.prevent.stop="showAttach(locTypeModel.attachId)"
                    >
                      <feather type="eye"></feather>Харах
                    </div>
                    <div
                      class="btn btn-outline-danger wd-50p"
                      @click.prevent.stop="locTypeModel.attachId = null"
                    >
                      <feather type="x"></feather>Болих
                    </div>
                  </div>
                </div>
              </simple-uploader>
            </FormItem>
            <FormItem
              v-if="locTypeModel.key == 'courseType'"
              label="Ковер зураг"
              class="m-b-sm"
            >
              <simple-uploader
                v-model="locTypeModel.field1"
                :propObjectTypeId="6"
                @on-success="coverUploaded"
              >
                <div slot="trigger">
                  <div
                    v-if="locTypeModel.field1 == null"
                    class="btn btn-primary"
                  >
                    <label style="margin-btoom: 0" class="custom-file-label"
                      >Файл сонгоогүй байна</label
                    >
                  </div>
                  <div v-else class="btn-group wd-100p ht-40-f">
                    <div
                      class="btn btn-outline-primary wd-50p"
                      @click.prevent.stop="
                        showAttach(locTypeModel.field1, true)
                      "
                    >
                      <feather type="eye"></feather>Харах
                    </div>
                    <div
                      class="btn btn-outline-danger wd-50p"
                      @click.prevent.stop="locTypeModel.field1 = null"
                    >
                      <feather type="x"></feather>Болих
                    </div>
                  </div>
                </div>
              </simple-uploader>
            </FormItem>
            <FormItem
              v-if="locTypeModel.key == 'courseType'"
              label="Төрлийн сургалтуудыг сурагчийн эхлэл хуудсанд харуулах ?"
              class="m-b-sm"
            >
              <Select v-model="locTypeModel.i1">
                <Option :value="0" label="Үгүй"></Option>
                <Option :value="1" label="Тийм"></Option>
              </Select>
            </FormItem>
            <FormItem
              v-if="locTypeModel.key == 'userManualMenu'"
              label="Харагдац"
              class="m-b-sm"
            >
              <Input v-model="locTypeModel.field1" placeholder="___" />
            </FormItem>
          </Form>
        </div>
      </div>
      <template #modal-footer>
        <!-- <div class="modal-footer pd-x-20 pd-y-15"> -->
          <button type="button" class="btn btn-white" @click="modalClose()">
            Болих
          </button>
          <button
            v-show="editMode"
            class="btn btn-primary"
            @click="saveLocType"
          >
            {{ selectedTypeId == 0 ? "Үүсгэх" : "Засах" }}
          </button>
        <!-- </div> -->
      </template>
    </b-modal>
    <!-- <Dialog :transition-names="[]" :visible.sync="modalShow" width="800" footer-hide :close-on-click-modal="false">
      
    </Dialog>-->
    <b-modal v-model="fileDialog.modal" hide-footer size="lg" scrollable>
      <template v-if="fileDialog.blank">
        <img class="wd-100p" :src="fileDialog.src" />
      </template>
      <file-dialog
        v-else
        :show="fileDialog.show"
        :id.sync="fileDialog.id"
        @on-hide="fileDialog.show = false"
        :force="true"
      />
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { getTypeTreeData } from "@/api/type";
import { request } from "@/api/all";
import { hasOneOf } from "@/libs/tools";
import "element-ui/lib/theme-chalk/index.css";
import {
  Cascader,
  //ButtonGroup,
  //Button,
  FormItem,
  InputNumber,
  Input,
  Form,
  Tree,
  Checkbox,
  Select,
  Option
} from "element-ui";

var LTT = require("list-to-tree");

var _ = require("lodash");

export default {
  components: {
    Cascader,
    //ButtonGroup,
    //Button,
    FormItem,
    InputNumber,
    Input,
    Form,
    Tree,
    Checkbox,
    Select,
    Option,
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/previewPage.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  name: "locTypeCascader",
  props: {
    id: {
      type: Number,
      default: () => 0
    },
    locTypekey: {
      type: String,
      default: () => ""
    },
    guid: {
      type: String,
      default: () => ""
    },
    getParentType: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    disableAdd: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: String,
      default: () => "medium"
    },
    checkStrictly: {
      type: Boolean,
      default: () => false
    },
    withUserId: {
      type: String,
      default: () => ""
    },
    parentFilterable: {
      type: Boolean,
      default: () => false
    },
    parentId: {
      type: Number,
      default: () => 0
    },
    placeholder:{
      type: String,
      default: () => "Сонгоно уу"
    }
  },
  data() {
    return {
      list: [],
      listFlat: [],
      cascaderSelected: [],
      modalShow: false,
      selectedTypeId: 0,
      selectedLabel: "",
      locTypeModel: {
        parentId: 0
      },
      editMode: false,
      postedId: 0,
      fileDialog: {
        modal: false,
        show: false,
        id: 0,
        blank: false,
        src: ""
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    sortByLabel(a, b) {
      return a.label.localeCompare(b.label);
    },
    sortTreeNodes(node, comparator) {
      let self= this;
      if (node.children!=undefined && node.children.length > 0) {
        // console.log('node', node);
        // node.children.sort(comparator);
        node.children= _.orderBy(node.children, ['ord', 'label'], ['asc','asc'])
        node.children.forEach(child => self.sortTreeNodes(child, comparator));
      }
    },
    compareById(vector) {
      return (a, b) => {
        const aid = Number(a.get('ord'));
        const bid = Number(b.get('ord'));
        if (aid > bid) {
          return vector ? 1 : -1;
        } else if (aid < bid) {
          return vector ? -1 : 1;
        } else {
          return 0
        }
      };
    },
    getLbl(){
      let rv='';
      if(this.locTypeModel.key == 'userManualMenu'){
        rv= 'Icon';
      } else if(this.locTypeModel.key == 'internalAuditProblemLegal'){
        rv= 'Legal info';
      }
      else rv= 'Код';
      return rv;
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    showAttach(id, blank) {
      if (blank != undefined && blank) {
        this.fileDialog.blank = true;
        this.fileDialog.src = id;
      } else {
        this.fileDialog.blank = false;
        this.fileDialog.id = id;
      }
      this.fileDialog.show = true;
      this.fileDialog.modal = true;
    },
    init() {
      getTypeTreeData({
        params: {
          key: this.locTypekey,
          getParentType: this.getParentType,
          userId: this.withUserId
        },
        store: this.$store
      }).then(res => {
        if (!this.parentFilterable) {
          if(this.locTypekey=='stptpCRM' && hasOneOf(['zuvlul.stf.gov.mn'], this.$store.state.app.activeGroup.hostPro)){
            res.data.types= res.data.types.filter(x=>hasOneOf([x.id], [346685, 346686]));
          }
          let dataTypes = res.data.types;
          
          // let dataTypes = _.orderBy(res.data.types, ["ord"], ["asc"]);
          // let dataTypes = _.orderBy(res.data.types, ["id"], ["asc"]);
          // console.log('dataTypes', dataTypes);

          this.listFlat = dataTypes;
          var ltt = new LTT(dataTypes, {
            key_id: "id",
            key_parent: "parentId",
            key_child: "children",
            // key_ord: "ord",
            label: "label"
          });
          // ltt.sort(this.compareById(true))
          this.list = ltt.GetTree();
          this.list = _.orderBy(ltt.GetTree(), ['ord', 'label'], ['asc','asc']);
          this.list.forEach(node => this.sortTreeNodes(node, this.sortByLabel));
          // console.log('list', this.list);
          //console.log('res.data.types', this.list);
          this.cascaderSelected = [];
          if (this.id > 0 || this.postedId > 0) {
            this.cascaderModelRecursive(
              this.listFlat,
              this.postedId > 0 ? this.postedId : this.id
            );
            this.cascaderSelected = this.cascaderSelected.reverse();
          } else this.cascaderSelected = [];
        } else {
          this.locTypeModel.parentId = this.parentId;
          let parentType = res.data.types.filter(x => x.id == this.parentId);
          let dataTypes = res.data.types.filter(
            x => x.parentId == this.parentId
          );
          this.listFlat = this.listFlat.concat(dataTypes);
          if (parentType.length > 0) this.listFlat.push(parentType[0]);
          this.list = dataTypes.map(x => {
            return x;
          });

          if (this.id > 0 || this.postedId > 0) {
            this.cascaderSelected = [this.id];
            // this.cascaderModelRecursive(
            //   this.listFlat,
            //   this.postedId > 0 ? this.postedId : this.id
            // );
            // this.cascaderSelected = this.cascaderSelected.reverse();
          } else this.cascaderSelected = [];

          //console.log("cascadered",this.cascaderSelected);
        }
      });
    },
    cascaderModelRecursive(data, cid) {
      this.cascaderSelected.push(cid);
      if (data.filter(d => d.id == cid).length) {
        let pid = data.filter(d => d.id == cid)[0].parentId;
        if (pid > 0) {
          this.cascaderModelRecursive(data, pid);
        }
      }
    },
    cascaderOnChange(value) {
       console.log('cascaderOnChange', value);
      if(value.length){
        let _id =
          value[value.length - 1] != undefined ? value[value.length - 1] : null;
        this.$emit("loctype-selected", { id: _id, guid: this.guid, dta: this.listFlat });
        this.$emit("input", _id);

        let selectedData = this.listFlat.filter(x => x.id == _id);
        this.$emit("loctype-selected_withdata", {
          id: _id,
          data: selectedData.length ? selectedData[0] : { code: "" }
        });
      }else {
        this.$emit("input", null);
        this.$emit("loctype-cleared");
      }
    },
    showModal() {
      this.modalShow = true;
      this.addSub(0);
    },
    modalClose() {
      this.locTypeModel = {};
      this.selectedTypeId = 0;
      this.modalShow = false;
    },
    handleTreeSelect(e) {
      //console.log('handleTreeSelect=> ', e, this.listFlat);
      if (e != null) {
        this.cascaderSelected = [];
        this.cascaderModelRecursive(this.listFlat, e.id);
        this.cascaderSelected = this.cascaderSelected.reverse();
        this.$emit("input", e.id);
        e.expand = true;
        this.selectedLabel = e.label;
        this.selectedTypeId = e.id;
        this.editSub(this.selectedTypeId);
      } else {
        this.cascaderSelected = [];
        this.$emit("input", 0);
        this.selectedTypeId = 0;
        this.selectedLabel = "";
      }
    },
    addSub(id) {
      if (id == 0) this.selectedTypeId = 0;
      this.editMode = true;

      this.locTypeDetail(0, id == 0 ? 0 : id);
    },
    deleteType(id) {
      // TODO: confirm-g nogoo goyo confirmooroo solih
      if (
        confirm(
          "Төрлийг устгах гэж байна. Үйлдлийг буцаах боломжгүй. Итгэлтэй байна уу?"
        )
      ) {
        request({
          data: { id: id },
          api: { url: "Type/DeleteType", method: "post" },
          store: this.$store
        }).then(res => {
          if (res != false) {
            this.editMode = false;
            this.selectedTypeId = 0;
            this.init();
          }
        });
      }
    },
    editSub(id) {
      this.editMode = true;
      this.locTypeDetail(id, 0);
    },

    locTypeDetail(id, pid) {
      request({
        params: { id: id, parentId: pid, key: this.locTypekey },
        api: { url: "Type/GetInheritedDetail", method: "get" },
        store: this.$store
      }).then(res => {
        //console.log('this.locTypeModel=> ', res.data);
        this.locTypeModel = res.data;
        // if(this.locTypeModel.key="courseType" && this.locTypeModel.i1==1){
        //   this.locTypeModel.i1= true;
        // }

        if (this.parentFilterable) this.locTypeModel.parentId = this.parentId;
      });
    },
    saveLocType() {
      // if(this.locTypeModel.i1==true){
      //   this.locTypeModel.i1=1;
      // }

      request({
        data: { model: this.locTypeModel },
        api: { url: "Type/PostType", method: "post" },
        store: this.$store
      }).then(res => {
        if (res != false) {
          this.editMode = false;
          this.postedId = res.data.typeId;
          this.selectedTypeId = res.data.typeId;
          this.init();
        }
      });
    },

    //# loc type attachment
    fileUploaded(e) {
      this.locTypeModel.attachId = e.uploadedAttachmentId;
    },
    coverUploaded(e) {
      this.locTypeModel.field1 = e.uploadedUrl;
    }
  }
};
</script>
